import React from 'react'

export default function LeadFooter(props) {
  const { prevStep, nextStep, stepName } = props

  return (
    <div className='flex justify-center border-t border-blue-300 p-4 bg-white'>
      <div className='w-full max-w-2xl grid gap-3 grid-cols-2 md:gap-8'>
        
        {stepName !== 'payer' ? (
          <button
            className={[
              'text-black border-black border py-2 rounded-full text-lg',
              'flex justify-center items-center'
            ]}
            data-test-id='prev'
            onClick={prevStep}
          >
            <span>Back</span>
          </button>
        ) : <div/> }

        <button
          className={[
            'btn btn-blue py-2 rounded-full text-lg text-center',
            'flex justify-center items-center'
          ]}
          data-test-id='next'
          onClick={nextStep}
        >
          <span>{stepName === 'contact' ? 'Submit' : 'Next'}</span>
        </button>
      </div>
    </div>
  )
}
